var path = '/pages/billing/position_categories/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing/position_categories/views/list.tpl.html
// module id = 2203
// module chunks = 1